import { ApolloLink, HttpLink } from '@apollo/client'
import { blogAppUrl } from '@scalis/config'

const httpLink = new HttpLink({
  uri: `${blogAppUrl}/graphql`,
})

export const link = ApolloLink.from([httpLink])
